/** @type {{data: {currentLang: any; defaultLang: any, isHE: boolean, currentCultureName: string}}} */
export let langCache = { data: undefined };